export enum CommunityRemovalStatus {
  Completed = 'Completed',
  InProgress = 'In Progress',
  Fail = 'Fail',
  Scheduled = 'Scheduled'
}
